module.exports = __webpack_public_path__ + "static/img/2.0b28f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/complete/2.png
// module id = wIDq
// module chunks = 1